export default {
  SOCKET_EVENT: {
    JOIN_JOB: "joinJob",
    REFRESH_JOB: "refreshJob",
    NOTIFY_REFETCH_JOB: "notifyRefetchJob",
    POST_COMMENT: "postComment",
    NEW_USER_CONNECTED: "newUserConnected",
    SEND_COMMENT_NOTI: "sendCommentNoti",
    SEND_SLOW_CLAP_NOTI: "sendSlowClapNoti",
    POST_SLOW_CLAP: "psotSlowClap",
    POST_COMMENT_LIKE: "postCommentLike",
    SEND_COMMENT_LIKE_NOTI: "sendCommentLikeNoti",
    REAL_TIME_EMIT: "realTimeEmit",
    REAL_TIME_FROM_SERVER: "realTimeFromServer",
    TOTAL_ACTIVE_USERS: "totalActiveUsers",
    BADGE_COMPLETED: "BADGE_COMPLETED",
    REFERRAL_SIGN_UP: "REFERRAL_SIGN_UP",
    SETUP_CHAT: "SETUP_CHAT",
    CHAT_CONNECTED: "CHAT_CONNECTED",
    JOIN_CHAT: "JOIN_CHAT",
    NEW_MESSAGE: "NEW_MESSAGE",
    MESSAGE_RECEIVED: "MESSAGE_RECEIVED",
    TYPING: "TYPING",
    STOP_TYPING: "STOP_TYPING",
    SEND_MESSAGE_NOTI: "SEND_MESSAGE_NOTI",
    SEND_UNREAD_MESSAGE_NOTIFICATION: "SEND_UNREAD_MESSAGE_NOTIFICATION",
    AUTOMATION_NOTIFICATION: "AUTOMATION_NOTIFICATION",
    KPIS_UPDATED: "KPIS_UPDATED",
    JOIN_COMPANY_FEED: "joinCompanyFeed",
    LEAVE_COMPANY_FEED: "leaveCompanyFeed",
    FEED_JOB_UPSERTED: "feedJobUpserted",
  },
};
